import { render } from "./ListeTypePiece.vue?vue&type=template&id=21a0696b&ts=true"
import script from "./ListeTypePiece.vue?vue&type=script&lang=ts"
export * from "./ListeTypePiece.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__